// Define all your routes here
import Root from './containers/Root';
import NotFound from './components/NotFound';
// import LoginPage from './containers/LoginPage/Loadable';
import RestaurantDeals from './containers/RestaurantDeals/Loadable';
import RestaurantsList from './containers/RestaurantsList/Loadable';
import RestaurantDetails from './containers/RestaurantDetails/Loadable';
import GiftCardLanding from './containers/GiftCardLanding/Loadable';
import GiftCardsList from './containers/GiftCardsList/Loadable';
import GiftCardProduct from './containers/GiftCardProduct/Loadable';
import PayBalance from './containers/PayBalance/Loadable';
import GiftCardCart from './containers/GiftCardCart/Loadable';
import RedeemZsc from './containers/RedeemZsc/Loadable';
import OrderSummary from './containers/OrderSummary/Loadable';
import ZingerCardDetailS from './containers/_ZingerCardDetails/Loadable';
import MyBookings from './containers/MyBookings/Loadable';
import ThankYou from './containers/ThankYou/Loadable';
import DeliveryAdd from './containers/_DeliveryAdd/Loadable';
import MyEGiftCards from './containers/MyEGiftCards/Loadable';
import Profile from './containers/Profile/Loadable';
import NetworkCards from './containers/NetworkCards/Loadable';
import ManageZaggleCard from './containers/ManageZaggleCard/Loadable';
import MyOrders from './containers/MyOrders/Loadable';
import OrderDetails from './containers/OrderDetails/Loadable';
import HandlePayment from './containers/HandlePayment';
import SearchResult from './containers/SearchResult/Loadable';
import TermsConditions from './containers/TermsConditions/Loadable';
import RefundPolicy from './containers/RefundPolicy/Loadable';
import PrivacyPolicy from './containers/PrivacyPolicy/Loadable';
import GrievancePolicy from './containers/GrievancePolicy/Loadable';
import PartnerWithUs from './containers/PartnerWithUs/Loadable';
import ActivateZsc from './containers/ActivateZsc/Loadable';
import EmailVerification from './containers/EmailVerification/Loadable';
import FaQs from './containers/FaQs/Loadable';
import { constants as Link } from './devUtils';
import Press from './containers/Press/';
import AppPrivacyPolicy from './containers/AppPrivacyPolicy/';
/**
 * @todo: middle layer need to be included in case of protected routes which require login
 */
import Propel from './containers/StaticPages/Propel/Loadable';
import Edge from './containers/StaticPages/Edge/Loadable';
import Save from './containers/StaticPages/Save/Loadable';
import AboutUS from './containers/StaticPages/AboutUS/Loadable';
import Team from './containers/StaticPages/Team/Loadable';
import AnnualGeneralMeeting from './containers/StaticPages/AnnualGeneralMeeting/Loadable';
import MCMD from './containers/StaticPages/MCMD/Loadable';
import DisclosuresRegulation from './containers/StaticPages/DisclosuresRegulation/Loadable';
import Merchant from './containers/StaticPages/Merchant/Loadable';
import Career from './containers/StaticPages/Career/Loadable';
import Pres from './containers/StaticPages/Press/Loadable';
import NewsInternal from './containers/StaticPages/Press/NewsInternalPage/Loadable';
import ContactUS from './containers/StaticPages/ContactUS/Loadable';
import Thankyou from './containers/StaticPages/Thankyou/Loadable';
import Calculator from './containers/StaticPages/Calculator/Loadable';
import SaveWip from './containers/StaticPages/SaveWip/Loadable';
import ClientLogin from './containers/ClientLogin/Loadable';
import CreateAccount from './containers/Profile/CreateAccount/Loadable';
import ActivateAccount from './containers/Profile/ActivateAccount/Loadable';
import NewLanding from './containers/NewLanding/Loadable';
import ComplaintModule from './containers/ComplaintModule/Loadable';
import SetPosPin from './containers/SetPOSPin/Loadable'; // New Routing For SetPosPin
import ChangeInternetPin from './containers/ChangeInternetPin/Loadable'; // New Routing ChangeInternetPin
import SolutionsWrapper from './containers/NewLanding/Solutions/Loadable';
import PayRollCard from './containers/PayRollCard/Loadable'; // New Routing Pay Roll Card
import PayRollCardContact from './containers/PayRollCardContact/Loadable'; // New Routing Pay Roll Card
import FundTransfer from './containers/FundTransfer/Loadable';
import Moneyfy from './containers/Campaigns/Moneyfy/Loadable';
import PropelCorporateGifting from './containers/Campaigns/PropelCorporateGifting/Loadable';
import Wearables from './containers/Wearables/Loadable'; // New Routing Wearables
import YscTransactionLimits from './containers/YscTransactionLimits/Loadable';
import YesRequestStatement from './containers/YesRequestStatement/Loadable';
import IndusIndRequestStatement from './containers/IndusIndRequestStatement/Loadable';
import WearableFaqs from './containers/WearableFaQs/Loadable';
import YesBankTransactionLimits from './containers/YesBankTransactionLimits/Loadable';
import YblMinKyc from './containers/YblMinKyc/Loadable';
import AuditCommittee from './containers/StaticPages/IPO/AuditCommittee/Loadable';
import AnnualReportsIPO from './containers/StaticPages/IPO/AnnualReports/Loadable';
import ZaggleOverview from './containers/StaticPages/IPO/ZaggleOverview/Loadable';
import BoardOfDirectors from './containers/StaticPages/IPO/BoardOfDirectors/Loadable';
import Financials from './containers/StaticPages/IPO/Financials/Loadable';
import DisclosureEventsInformation from './containers/StaticPages/IPO/DisclosureEventsInformation/Loadable';
import FinancialResultsPublishedNewspaper from './containers/StaticPages/IPO/FinancialResultsPublishedNewsPaper/Loadable';
import DisclosuresRegulationGeneralMeetings from './containers/StaticPages/IPO/DisclosuresRegulationGeneralMeetings/Loadable';
import DirectorsProfile from './containers/StaticPages/IPO/BoardOfDirectors/DirectorsProfile/Loadable';
import IndusindMinKyc from './containers/IndusindMinKyc/Loadable';
import YscCardActions from './containers/YscCardActions/Loadable';
import PartnerBanners from './containers/PartnerBanners/Loadable';
import YblMinKycExistingUsers from './containers/YblMinKycExistingUsers/Loadable';
import YesBankRenewalManagement from './containers/YesBankRenewalManagement/Loadable';
import YscWalletLockUnlock from './containers/YscWalletLockUnlock/Loadable';
import YesBankReplaceCard from './containers/YesBankReplaceCard/Loadable';
import YesBankFaqs from './containers/YesBankFaQs/loadable';
import IndusindKuberCardsFaq from './containers/IndusindKuberCardsFaq/Loadable';
import IndusindZingerCardsFaqs from './containers/IndusindZingerCardsFaqs/loadable';
import LyraPaymentStatus from './containers/LyraPaymentStatus/Loadable';

export default [
  {
    ...Root,
    routes: [
      {
        path: '/',
        ...ManageZaggleCard,
        exact: true,
      },
      {
        path: Link.LYRA_PG_LOGIN,
        ...ManageZaggleCard,
      },
      {
        path: Link.LINK_RESTAURANTS_DEALS,
        ...RestaurantDeals,
        exact: true,
      },
      {
        path: `${Link.LINK_RESTAURANTS}/:selectedCity-restaurants`,
        ...RestaurantsList,
        exact: true,
      },
      {
        path: `${Link.LINK_RESTAURANTS}/:selectedCity-restaurants/:filterKey`,
        ...RestaurantsList,
        exact: true,
      },
      {
        path: `${Link.LINK_RESTAURANTS_DETAILS}/:restaurantId`,
        ...RestaurantDetails,
        exact: true,
      },
      {
        path: `${Link.LINK_GIFTCARD_LANDING}`,
        ...GiftCardLanding,
        exact: true,
        isFbAnalyticsEnabled: true,
      },
      {
        path: `${Link.LINK_GIFTCARD_LIST}`,
        ...GiftCardsList,
        exact: true,
        isFbAnalyticsEnabled: true,
      },
      {
        path: `${Link.LINK_GIFTCARD_LIST}/:filterName`,
        ...GiftCardsList,
        exact: true,
        isFbAnalyticsEnabled: true,
      },
      {
        path: Link.LYRA_PG_LINK_GIFTCARD_LIST,
        ...GiftCardsList,
        exact: true,
        isFbAnalyticsEnabled: true,
      },
      {
        path: Link.LINK_SPECIAL_DEALS_AND_OFFERS,
        ...GiftCardsList,
        exact: true,
        isFbAnalyticsEnabled: true,
      },
      {
        path: `${Link.LINK_SPECIAL_DEALS_AND_OFFERS}/:filterName`,
        ...GiftCardsList,
        exact: true,
        isFbAnalyticsEnabled: true,
      },
      {
        path: `${Link.LINK_GIFTCARD_DETAILS}/:productName`,
        ...GiftCardProduct,
        exact: true,
        isFbAnalyticsEnabled: true,
      },
      {
        path: `${Link.LINK_PAY_BALANCE}`,
        ...PayBalance,
        exact: true,
      },
      {
        path: Link.GIFT_CARD_CART,
        ...GiftCardCart,
        exact: true,
        isFbAnalyticsEnabled: true,
      },
      {
        path: Link.LINK_REDEEM_ZSC,
        ...RedeemZsc,
        exact: true,
      },
      {
        path: Link.LINK_ORDER_SUMMARY,
        ...OrderSummary,
        exact: true,
        isFbAnalyticsEnabled: true,
      },
      {
        path: '/zinger-card-details',
        ...ZingerCardDetailS,
        exact: true,
      },
      {
        path: Link.LINK_MY_BOOKINGS,
        ...MyBookings,
      },
      {
        path: `${Link.LINK_CONFIRM}/:confirmType`,
        ...ThankYou,
        exact: true,
      },
      {
        path: Link.LINK_DELHIVERY_ADDRESS,
        ...DeliveryAdd,
        exact: true,
      },
      {
        path: Link.LINK_MY_EVOUCHERS,
        ...MyEGiftCards,
        exact: true,
      },
      {
        path: Link.LINK_MY_PROFILE,
        ...Profile,
        exact: true,
        isAuth: true,
      },
      {
        path: `${Link.LINK_ZAGGLE_CARD_DEAILS}/:id`,
        ...NetworkCards,
        exact: true,
      },
      {
        path: Link.LINK_MANAGE_ZAGGLE_CARD,
        ...ManageZaggleCard,
        exact: true,
      },
      {
        path: Link.APP_LOGIN,
        ...ManageZaggleCard,
        exact: true,
      },
      {
        path: Link.LINK_MY_ORDERS,
        ...MyOrders,
        exact: true,
      },
      {
        path: '/order-details',
        ...OrderDetails,
        exact: true,
      },
      {
        path: Link.LINK_PAYU_SUCCESS,
        ...HandlePayment,
        exact: true,
      },
      {
        path: Link.LINK_PAYU_FAIL,
        ...HandlePayment,
        exact: true,
      },
      {
        path: Link.LINK_MOBIKWIK,
        ...HandlePayment,
        exact: true,
      },
      {
        path: Link.LINK_SEARCH_RESULT,
        ...SearchResult,
        exact: true,
      },
      {
        path: Link.LINK_TERMS_CONDITIONS,
        ...TermsConditions,
        exact: true,
      },
      {
        path: Link.LINK_REFUND_POLICY,
        ...RefundPolicy,
        exact: true,
      },
      {
        path: Link.LINK_PRIVACY_POLICY,
        ...PrivacyPolicy,
        exact: true,
      },
      {
        path: Link.LINK_GRIEVANCE_POLICY,
        ...GrievancePolicy,
        exact: true,
      },
      {
        path: Link.LINK_FAQS,
        ...FaQs,
        exact: true,
      },
      {
        path: Link.LINK_PARTNER_WITH_US,
        ...PartnerWithUs,
        exact: true,
        to: Link.LINK_PARTNER_WITH_US,
      },
      {
        path: Link.LINK_ZAGGLE_CARD,
        ...ActivateZsc,
        exact: true,
      },
      {
        path: Link.LINK_SET_TOKEN,
        ...EmailVerification,
        exact: true,
      },
      {
        path: `${Link.LINK_CAREERS}`,
        ...Career,
        exact: true,
      },
      {
        path: `${Link.LINK_E_VOUCHERS}/:linkToken`,
        ...EmailVerification,
        exact: true,
      },
      {
        path: Link.LINK_OLDPRESS,
        ...Press,
        exact: true,
      },
      {
        path: Link.LINK_NEWS_INTERNAL,
        ...NewsInternal,
        exact: true,
      },
      {
        path: '/app/privacy-policy',
        ...AppPrivacyPolicy,
        exact: true,
      },
      {
        path: Link.LINK_PROPEL,
        ...Propel,
        exact: true,
      },
      {
        path: Link.LINK_EDGE,
        ...Edge,
        exact: true,
      },
      {
        path: Link.LINK_SAVE,
        ...SaveWip,
        exact: true,
      },
      {
        path: Link.LINK_ABOUT_US,
        ...AboutUS,
        exact: true,
      },
      {
        path: Link.LINK_ZAGGLE_OVERVIEW,
        ...ZaggleOverview,
        exact: true,
      },
      {
        path: Link.LINK_ANNUAL_GENERAL_MEETING,
        ...AnnualGeneralMeeting,
        exact: true,
      },
      {
        path: Link.LINK_MCMD,
        ...MCMD,
        exact: true,
      },
      {
        path: Link.LINK_DISCLOSURES_REGULATION,
        ...DisclosuresRegulation,
        exact: true,
      },
      {
        path: Link.LINK_TEAM,
        ...Team,
        exact: true,
      },
      {
        path: Link.LINK_MERCHANT,
        ...Merchant,
        exact: true,
      },
      {
        path: Link.LINK_CAREERS,
        ...Career,
        exact: true,
      },
      {
        path: Link.LINK_PRESS,
        ...Pres,
        exact: true,
      },
      {
        path: Link.LINK_CONTACTUS,
        ...ContactUS,
        exact: true,
      },
      {
        path: Link.LINK_THANKYOU,
        ...Thankyou,
      },
      {
        path: Link.LINK_CALCULATOR,
        ...Calculator,
        exact: true,
      },
      {
        path: '/save-wip',
        ...Save,
        exact: true,
      },
      {
        path: Link.LINK_ACCOUNT_CREATION,
        ...CreateAccount,
        exact: true,
      },
      {
        path: Link.LINK_ACCOUNT_ACTIVATE,
        ...ActivateAccount,
        exact: true,
      },
      {
        path: Link.LINK_NEW_LANDING,
        ...NewLanding,
        exact: true,
      },
      {
        path: Link.LINK_SOLUTIONS,
        ...SolutionsWrapper,
        exact: true,
      },
      {
        path: Link.SETPOSPIN, // New Routing For SetPosPin
        ...SetPosPin,
        exact: true,
      },
      {
        path: Link.CONTANTS.COMPLAINT_MODULE,
        ...ComplaintModule,
        exact: true,
      },
      {
        path: Link.CHANGE_INTERNET_PIN, // New Routing For ChangeInternetPin
        ...ChangeInternetPin,
        exact: true,
      },
      {
        path: Link.LINK_PAYROLL_CARD, // New Routing For PayRollCard
        ...PayRollCard,
        exact: true,
      },
      {
        path: Link.LINK_PAYROLL_CARD_CONTACT, // New Routing For PayRollCardContact
        ...PayRollCardContact,
        exact: true,
      },
      {
        path: Link.CONTANTS.LINK_FUND_TRANSFER,
        ...FundTransfer,
        exact: true,
      },
      {
        path: Link.CAMPAIGN_MONEYFY, // New Routing For Moneyfy Campaign.
        ...Moneyfy,
        exact: true,
      },
      {
        path: Link.LINK_CLIENT_MANIPAL,
        ...GiftCardsList,
        exact: true,
        isFbAnalyticsEnabled: true,
      },
      {
        path: Link.LINK_MANIPAL_ABOUTUS,
        ...ClientLogin,
        exact: true,
      },
      {
        path: Link.LINK_MANIPAL_REFUN_RETURN_POLICY,
        ...RefundPolicy,
        exact: true,
      },
      {
        path: Link.LINK_PROPEL_CORPORATE_GIFITING,
        ...PropelCorporateGifting,
        exact: true,
      },
      {
        path: Link.LINK_PROPEL_CORPORATE_GIFITING_HOME,
        ...GiftCardsList,
        exact: true,
      },
      {
        path: Link.LINK_WEARABLES,
        ...Wearables,
      },
      {
        path: `${Link.LINK_ZAGGLE_CARD_M2P}/:id`,
        ...NetworkCards,
        exact: true,
      },
      {
        path: Link.CONTANTS.LINK_NSDL_FUND_TRANSFER,
        ...FundTransfer,
        exact: true,
      },
      {
        path: `${Link.YSC_BANK_LIMITS}/:id`,
        ...YscTransactionLimits,
        exact: true,
      },
      {
        path: Link.YES_REQUEST_STATEMENT,
        ...YesRequestStatement,
        exact: true,
      },
      {
        path: `${Link.INDUSIND_REQUEST_STATEMENT}/:id`,
        ...IndusIndRequestStatement,
        exact: true,
      },
      {
        path: Link.CONTANTS.YES_BANK_WEARABLES_FAQS,
        ...WearableFaqs,
        exact: true,
      },
      {
        path: Link.YES_BANK_LIMITS,
        ...YesBankTransactionLimits,
        exact: true,
      },
      {
        path: Link.YBL_MIN_KYC,
        ...YblMinKyc,
        exact: true,
      },
      {
        path: Link.AUDIT_COMMITTEE,
        ...AuditCommittee,
        exact: true,
      },
      {
        path: Link.ANNUAL_REPORTS_IPO,
        ...AnnualReportsIPO,
        exact: true,
      },
      {
        path: Link.BOARD_OF_DIRECTORS,
        ...BoardOfDirectors,
        exact: true,
      },
      {
        path: Link.DIRECTORS_PROFILE,
        ...DirectorsProfile,
        exact: true,
      },
      {
        path: Link.INDUSIND_MIN_KYC,
        ...IndusindMinKyc,
        exact: true,
      },
      {
        path: Link.FINANCIALS,
        ...Financials,
        exact: true,
      },
      {
        path: Link.DISCLOSURE_EVENTS_INFORMATION,
        ...DisclosureEventsInformation,
        exact: true,
      },
      {
        path: Link.FINANCIAL_RESULTS_PUBLISHED_NEWSPAPER,
        ...FinancialResultsPublishedNewspaper,
        exact: true,
      },
      {
        path: Link.DISCLOSURES_REGULATION_GENERAL_MEETINGS,
        ...DisclosuresRegulationGeneralMeetings,
        exact: true,
      },
      {
        path: `${Link.YSC_BLOCK_CARD}/:id`,
        ...YscCardActions,
        exact: true,
      },
      {
        path: `${Link.YSC_LOCK_CARD}/:id`,
        ...YscCardActions,
        exact: true,
      },
      {
        path: `${Link.YSC_UNLOCK_CARD}/:id`,
        ...YscCardActions,
        exact: true,
      },
      {
        path: Link.LINK_PARTNERS_MOBILE,
        ...PartnerBanners,
        exact: true,
      },
      {
        path: Link.YBL_EXISTING_USERS,
        ...YblMinKycExistingUsers,
        exact: true,
      },
      {
        path: Link.INDUSIND_MIN_KYC,
        ...IndusindMinKyc,
        exact: true,
      },
      {
        path: Link.YES_BANK_CARD_RENEWAL_MANAGEMENT,
        ...YesBankRenewalManagement,
        exact: true,
      },
      {
        path: `${Link.YSC_WALLET_LOCK_UNLOCK}/:id`,
        ...YscWalletLockUnlock,
        exact: true,
      },
      {
        path: Link.YES_BANK_REPLACE_CARD_PATH,
        ...YesBankReplaceCard,
        exact: true,
      },
      {
        path: `${Link.YSC_WALLET_LOCK_UNLOCK}/:id`,
        ...YscWalletLockUnlock,
        exact: true,
      },
      {
        path: Link.INDUSIND_BANK_ZINGER_CARDS_FAQS,
        ...IndusindZingerCardsFaqs,
        exact: true,
      },
      {
        path: Link.YES_BANK_FAQS,
        ...YesBankFaqs,
        exact: true,
      },
      {
        path: Link.INDUSIND_BANK_KUBER_CARDS_FAQS,
        ...IndusindKuberCardsFaq,
        exact: true,
      },
      {
        path: `${Link.LYRA_PG_PAYMENT_STATUS}/:status`,
        ...LyraPaymentStatus,
        exact: true,
      },
      {
        component: NotFound,
      },
    ],
  },
];



// WEBPACK FOOTER //
// client/routes.js